import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject, ProfileBadges, ReduxEntity } from 'Douleutaras/types';
import { RootState } from 'Douleutaras/redux/store';

const sellerProfilesBadgesAdapter = createEntityAdapter<JSONApiDataObject<ProfileBadges>>({
  selectId: item => item.id
});

export const sellerProfilesBadgesSlice = createSlice({
  name: 'sellerProfilesBadges',
  initialState: sellerProfilesBadgesAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<JSONApiDataObject<ProfileBadges>>),
  reducers: {
    sellerProfilesBadgesAdded: (state, action) => {
      sellerProfilesBadgesAdapter.setMany(state, action.payload);
    }
  }
});

export const sellerProfilesBadgesSelectors = sellerProfilesBadgesAdapter.getSelectors(
  (state: RootState) => state.sellerProfilesBadges);
export default sellerProfilesBadgesSlice.reducer;
